import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type PauseIconProps = Partial<SVGIconProps>;

const PauseIcon: FC<PauseIconProps> = (props) => (
  <SVGIcon {...props} fill="none" height="20" viewBox="0 0 20 20" width="20">
    <rect fill="#0D121C" height="12" rx="0.5" width="2.5" x="6" y="4" />
    <rect fill="#0D121C" height="12" rx="0.5" width="2.5" x="11.5" y="4" />
  </SVGIcon>
);

export default PauseIcon;
